import React from "react";

const ClientInfo = ({ formData, handleChange, setActiveTab, isAdd, errors = {}, onNext }) => {
    return (
        <div id="client-info" className="content">
            <div className="row g-3 justify-content-center">
                {/* Row 1: Name - Gender - DOB */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className={`form-control ${errors.clientName ? 'is-invalid' : ''}`}
                            name="clientName"
                            value={formData.clientName}
                            onChange={handleChange}
                            placeholder="Name"
                            disabled={isAdd}
                        />
                        <label>Name</label>
                        {errors.clientName && (
                            <div className="invalid-feedback">{errors.clientName}</div>
                        )}
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <select
                            className={`form-select ${errors.clientGender ? 'is-invalid' : ''}`}
                            name="clientGender"
                            value={formData.clientGender}
                            onChange={handleChange}
                            disabled={isAdd}
                        >
                            <option value="">Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                        <label>Gender</label>
                        {errors.clientGender && (
                            <div className="invalid-feedback">{errors.clientGender}</div>
                        )}
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className={`form-control ${errors.clientDOB ? 'is-invalid' : ''}`}
                            name="clientDOB"
                            value={formData.clientDOB}
                            onChange={handleChange}
                            placeholder=""
                            disabled={isAdd}
                        />
                        <label>DOB</label>
                        {errors.clientDOB && (
                            <div className="invalid-feedback">{errors.clientDOB}</div>
                        )}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className={`form-control ${errors.client_cnic ? 'is-invalid' : ''}`}
                            name="client_cnic"
                            value={formData.client_cnic || ""}
                            onChange={handleChange}
                            placeholder="Client CNIC"
                            disabled={isAdd}
                        />
                        <label>Client CNIC</label>
                        {errors.client_cnic && (
                            <div className="invalid-feedback">{errors.client_cnic}</div>
                        )}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className={`form-control ${errors.client_phone ? 'is-invalid' : ''}`}
                            name="client_phone"
                            value={formData.client_phone || ""}
                            onChange={handleChange}
                            placeholder="Client Phone"
                            disabled={isAdd}
                        />
                        <label>Client Phone</label>
                        {errors.client_phone && (
                            <div className="invalid-feedback">{errors.client_phone}</div>
                        )}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="email"
                            className={`form-control ${errors.client_email ? 'is-invalid' : ''}`}
                            name="client_email"
                            value={formData.client_email || ""}
                            onChange={handleChange}
                            placeholder="Client Email"
                            disabled={isAdd}
                        />
                        <label>Client Email</label>
                        {errors.client_email && (
                            <div className="invalid-feedback">{errors.client_email}</div>
                        )}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className={`form-control ${errors.client_address ? 'is-invalid' : ''}`}
                            name="client_address"
                            value={formData.client_address || ""}
                            onChange={handleChange}
                            placeholder="Client Address"
                            disabled={isAdd}
                        />
                        <label>Client Address</label>
                        {errors.client_address && (
                            <div className="invalid-feedback">{errors.client_address}</div>
                        )}
                    </div>
                </div>
                {/* Row 2: Education - No of Siblings - Birth Order */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="clientEducation"
                            value={formData.clientEducation}
                            onChange={handleChange}
                            placeholder="Education"
                        />
                        <label>Education</label>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="number"
                            className="form-control"
                            name="clientSiblings"
                            value={formData.clientSiblings}
                            onChange={handleChange}
                            placeholder="No. of Siblings"
                        />
                        <label>No. of Siblings</label>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="clientBirthOrder"
                            value={formData.clientBirthOrder}
                            onChange={handleChange}
                            placeholder="Birth Order"
                        />
                        <label>Birth Order</label>
                    </div>
                </div>
                {/* Row 3: History of Mental Illness */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        History of Mental Illness in Family
                    </small>
                    <div className="checkbox-group d-flex justify-content-center">
                        {["Yes", "No"].map((option) => {
                            const inputId = `familyMentalIllness-${option}`;

                            return (
                                <div className="form-check form-check-inline mb-2" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="familyMentalIllness"
                                        id={inputId}
                                        value={option}
                                        checked={formData.familyMentalIllness === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>
                                    {option === "Yes" && formData.familyMentalIllness === "Yes" && (
                                        <div className="form-floating form-floating-outline mt-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="familyMentalIllnessDetails"
                                                value={formData.familyMentalIllnessDetails}
                                                onChange={handleChange}
                                                placeholder="specify dates, reasons, and services availed"
                                            />
                                            <label>specify dates, reasons, and services availed</label>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                </div>
                {/* Row 4: Diagnosis - Diagnosis Since */}
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="diagnosis"
                            value={formData.diagnosis}
                            onChange={handleChange}
                            placeholder="Diagnosis"
                        />
                        <label>Diagnosis</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="diagnosisSince"
                            value={formData.diagnosisSince}
                            onChange={handleChange}
                        />
                        <label>Diagnosis Since (Date)</label>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className="form-control"
                            name="presentingComplaints"
                            value={formData.presentingComplaints || ""}
                            onChange={handleChange}
                            placeholder="Presenting Complaints"
                            style={{ height: "100px" }}
                        ></textarea>
                        <label>Presenting Complaints</label>
                    </div>
                </div>
                {/* Row 5: Currently under care */}
                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="currentCare"
                            value={formData.currentCare}
                            onChange={handleChange}
                            placeholder="Currently under care of (Psychiatrist/Psychologist)"
                        />
                        <label>Currently under care of (Psychiatrist/Psychologist)</label>
                    </div>
                </div>
                {/* Row 6: TRH Services */}
                <div className="col-md-6">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Previously availed TRH services?
                    </small>
                    <div className="checkbox-group d-flex justify-content-center">
                        {["Yes", "No"].map((option) => {
                            const inputId = `trhServices-${option}`;
                            return (
                                <div className="form-check form-check-inline mb-2" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="trhServices"
                                        id={inputId}
                                        value={option}
                                        checked={formData.trhServices === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>

                                    {option === "Yes" && formData.trhServices === "Yes" && (
                                        <div className="form-floating form-floating-outline mt-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="trhServicesDetails"
                                                value={formData.trhServicesDetails}
                                                onChange={handleChange}
                                                placeholder="specify dates, reasons, and services availed"
                                            />
                                            <label>specify dates, reasons, and services availed</label>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* Row 7: Substance Use */}
                <div className="col-md-6">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        History of substance use or disorder?
                    </small>
                    <div className="checkbox-group d-flex justify-content-center">
                        {["Yes", "No"].map((option) => {
                            const inputId = `substanceUse-${option}`;
                            return (
                                <div className="form-check form-check-inline mb-2" key={option}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="substanceUse"
                                        id={inputId}
                                        value={option}
                                        checked={formData.substanceUse === option}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor={inputId}>
                                        {option}
                                    </label>

                                    {option === "Yes" && formData.substanceUse === "Yes" && (
                                        <div className="form-floating form-floating-outline mt-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="substanceUseDetails"
                                                value={formData.substanceUseDetails}
                                                onChange={handleChange}
                                                placeholder="specify substances used and duration/frequency"
                                            />
                                            <label>specify substances used and duration/frequency</label>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* Buttons */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm btn-prev w-100"
                            onClick={() => setActiveTab("enquirer-info")}
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm btn-next ms-2 w-100"
                            onClick={onNext}
                        >
                            Next <i className="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientInfo;